import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AccessControlService } from './access-control.service';

export type PermissionKey =
  | 'administration'
  | 'reception-operation'
  | 'tenants-create'
  | 'tenants-manage'
  | 'locations-manage'
  | 'users-manage'
  | 'units-manage'
  | 'vendor-catalogs-view'
  | 'vendor-catalogs-manage';

function hasPermission(access: AccessControlService, permission: PermissionKey): boolean {
  switch (permission) {
    case 'administration':
      return access.canAccessAdministration();
    case 'reception-operation':
      return access.canOperateReception();
    case 'tenants-create':
      return access.canCreateTenants();
    case 'tenants-manage':
      return access.canManageTenants();
    case 'locations-manage':
      return access.canManageLocations();
    case 'users-manage':
      return access.canManageUsers();
    case 'units-manage':
      return access.canManageUnits();
    case 'vendor-catalogs-view':
      return access.canViewVendorCatalogs();
    case 'vendor-catalogs-manage':
      return access.canManageVendorCatalogs();
  }
}

export function permissionGuard(
  permission: PermissionKey,
  redirectTo: string
): CanActivateFn {
  return () => {
    const access = inject(AccessControlService);
    const router = inject(Router);

    return hasPermission(access, permission) ? true : router.createUrlTree([redirectTo]);
  };
}
